export const styles = {
  button: {
    margin: '10px 0',
  },
  buttonNumber: {
    margin: '10px 0'
  },
  pageInfo: {
    fontSize: 12,
    padding: '1.2em',
  },
  mobileToolbar: {
    margin: 'auto',
  },
  container: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
  },
  fontButton: {
    fontSize:10
  },
  fontButtonSelected: {
    fontSize:10,
    color: '#FFFFFF'
  }

};


// WEBPACK FOOTER //
// ./src/components/pagination/styles.js